import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { FAQ as FAQ_DATA, COMPANY } from "@/data/content";

// Split FAQ into two columns for readability
function split(arr) {
  const mid = Math.ceil(arr.length / 2);
  return [arr.slice(0, mid), arr.slice(mid)];
}

export default function FAQ() {
  const [colA, colB] = split(FAQ_DATA);

  return (
    <section id="faq" data-testid="faq" className="py-24 md:py-32 bg-brand-mist">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <Reveal className="mb-14 max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-brand-golddark">
            <span className="w-8 h-px bg-brand-gold" /> Questions fréquentes
          </span>
          <h2 className="mt-5 font-display font-semibold text-4xl md:text-6xl tracking-tight text-brand-navy leading-[1.05]">
            Vos questions, nos réponses
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Tout ce qu&apos;il faut savoir avant de faire appel à votre serrurier
            à Lagny-sur-Marne et alentours.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-x-10">
          {[colA, colB].map((col, ci) => (
            <Accordion key={ci} type="single" collapsible className="w-full">
              {col.map((f, i) => {
                const idx = ci === 0 ? i : colA.length + i;
                return (
                  <AccordionItem
                    key={idx}
                    value={`item-${idx}`}
                    className="border-b border-brand-line"
                  >
                    <AccordionTrigger
                      data-testid={`faq-trigger-${idx}`}
                      className="text-left font-display font-medium text-base md:text-lg tracking-tight text-brand-navy hover:text-brand-golddark hover:no-underline py-5"
                    >
                      {f.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-slate-600 text-base leading-relaxed pb-5">
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                );
              })}
            </Accordion>
          ))}
        </div>

        <Reveal className="mt-14">
          <div className="rounded-2xl bg-brand-navy p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <div className="font-display font-semibold text-2xl text-white">
                Une autre question ? Appelez-nous.
              </div>
              <p className="text-white/70 mt-1">
                Un serrurier vous répond immédiatement, 24h/24 et 7j/7.
              </p>
            </div>
            <a
              href={`tel:${COMPANY.phoneTel}`}
              data-testid="faq-call-btn"
              className="inline-flex items-center gap-3 bg-brand-gold hover:bg-brand-golddark text-brand-navy px-8 py-4 rounded-full font-semibold text-base transition-colors duration-300 shrink-0"
            >
              <Phone className="w-5 h-5" /> {COMPANY.phoneDisplay}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
